import { Component } from '@angular/core';

import { CamEventCardComponent, eventCardImports } from '../card.component';

@Component({
  selector: 'app-planning-scheduler-event-card',
  templateUrl: '../card.component.html',
  styleUrl: '../card.component.scss',
  imports: eventCardImports,
})
export class CamSchedulerEventCardComponent extends CamEventCardComponent {}
